type FooterSeoLinkItem = {
  label: string;
  href: string;
};

export type FooterSeoLinkSection = {
  title: string;
  items: FooterSeoLinkItem[];
};

export function FooterSeoLinks({ sections }: { sections: FooterSeoLinkSection[] }) {
  return (
    <section className="bg-white" aria-label="Footer SEO links">
      <div className="container-fluid py-10">
        <div className="space-y-10">
          {sections.map((section, sectionIdx) => (
            <div key={section.title}>
              <h3 className="mb-4 text-[18px] leading-[20px] text-[#032c5e]">
                {section.title}
              </h3>
              <div className="flex flex-wrap items-center">
                {section.items.map((item, idx) => (
                  <span key={`${section.title}-${item.href}`}>
                    <a
                      href={item.href}
                      className="inline-block whitespace-nowrap text-[14px] leading-[20px] text-[#032c5e] hover:underline underline-offset-4"
                    >
                      {item.label}
                    </a>
                    {idx < section.items.length - 1 ? (
                      <span className="mx-2 text-[#032c5e]">|</span>
                    ) : null}
                  </span>
                ))}
              </div>
              {sectionIdx < sections.length - 1 ? (
                <div className="mt-6 border-b border-[#032c5e]/20" />
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

